class MFRFixedBar {
    constructor( i, e ) {
        this.$index = i;
        this.$element = $( e );

        this.selectors = {
            bar: "[data-sticky-bar]",
        }

        this.init();
    }

    init() {
        this.$bar = this.$element.find( this.selectors.bar );

        if(!this.$bar.length) return;

        this.__handleOnScroll();
    }

    __handleOnScroll() {
        if ($(window).width() > 768) {
            const offsetTop = this.$bar.offset().top;
            const offsetLeft = this.$bar.offset().left;
            const width = this.$bar.width();

            // Apply initial styles
            this.$bar.css({ width, left: offsetLeft });

            // Function to handle bar animations
            const animateBar = (addSticky) => {
                gsap.to(this.$bar, {
                    duration: 0.1,
                    opacity: 0,
                    onComplete: () => {
                        if (addSticky) {
                            this.$bar.addClass("sticky-bar");
                        } else {
                            this.$bar.removeClass("sticky-bar");
                        }
                        gsap.to(this.$bar, {
                            duration: 0.1,
                            delay: 0.3,
                            opacity: 1,
                        });
                    },
                });
            };

            $(window).on("scroll", () => {
                const shouldStick = window.scrollY >= offsetTop;
                const isSticky = this.$bar.hasClass("sticky-bar");

                if (shouldStick && !isSticky) {
                    animateBar(true);
                } else if (!shouldStick && isSticky) {
                    animateBar(false);
                }
            });
        }
    }
}